import template from './component.tpl.html';
class BookableObjectsController {
    constructor(http, scope, env) {
        this.http = http;
        this.scope = scope;
        this.env = env;
        this.init();
        this.data = [];
        this.error = false;
        this.loading = true;
    }

    init() {
        this.initWatchers();
    }

    initWatchers() {
        this.scope.$watch(() => {
            return this.guestlistId;
        }, (newVal) => {
            this.updateData();
        });
    }

    updateData() {
        this.data = [];
        this.loading = true;
        this.error = false;

        this.http.post(this.env.apiUrl + '/stats/guestlists/seatplan-elements/stats', {
            guestlist_id: this.guestlistId
        }).then((response) => {
            this.loading = false;
            this.data = response.data.entries;
            this.applyAsync();
        }, () => {
            this.loading = false;
            this.error = true;
        });
    }

    applyAsync(){
        this.scope.$evalAsync();
    }
}

BookableObjectsController.$inject = [
    '$http',
    '$scope',
    'Env'
];

angular.module('festzelt-os.components.stats')
    .component('guestlistSeatplanElementsStats', {
        bindings: {
            'guestlistId': '<'
        },
        controller: BookableObjectsController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/stats/components/guestlists/seatplan-elements/component.js